import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Substract: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.00806 12V13.008H12.0001H22.9921V12V10.992H12.0001H1.00806V12Z'
        fill={fill}
      />
    </svg>
  )
}

export default Substract
